module.exports = __webpack_public_path__ + "img/block1_suvenirnaya-produkciya.cc4ff3b3.png";